document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll(".subNav-menu-select").forEach(function(el) {
    el.addEventListener('change', function() {
      var selected = el.options[el.selectedIndex];
      if (selected) window.location = selected.value;
    });
  });
});
